import React, { useEffect, useState, useCallback, useRef } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import Loader from './Loader';
import Turnstile from './Turnstile';
import { notification } from './util/NotificationManager';
import NotificationContainer from './NotificationContainer';
import { Helmet } from 'react-helmet-async';
export default function InfoCancha() {
  
  const navigate = useNavigate();
  const diasSemana = useRef(["Domingo", "Lunes", "Martes", "Miercoles", "Jueves", "Viernes", "Sabado"])
  const [id, setId] = useState(null)
  const [Establecimiento, setEstablecimiento] = useState(null)
  const [selectedTipoCancha, setSelectedTipoCancha] = useState(null)
  const [selectedDate, setSelectedDate] = useState(new Date())
  const [cargando, setCargando] = useState(true)
  const [cargaReserva, setCargaReserva] = useState(false)
  const [horario, setHorario] = useState(null)
  const [reservasActivas,setReservasActivas] = useState(null)
  const [canchaF5,setCanchaF5] = useState([])
  const [canchaF7,setCanchaF7] = useState([])
  const [fechasParaSeleccionar,setFechasParaSeleccionar] = useState([])
  const [horas, setHoras] = useState([])
  const [selectedHora, setSelectedHora] = useState(null)
  const [isFormOpen, setFormOpen] = useState(false)
  const [deposito, setDeposito] = useState(null)
  const [precio, setPrecio] = useState(null)
  const [contadorReservas,setContadorReservas] = useState(0)
  const [errors, setErrors] = useState('');
  const [consultaInicial, setConsultaInicial] = useState(false);
  const [validCard, setValidCard] = useState(null);
  const [captchaToken, setCaptchaToken] = useState("");
  
  const turnstileRef = useRef();
  const {slug} = useParams();
  
  const [datos, setDatos] = useState({
    email: '',
    nombre:'',
    apellido:'',
    telefono:'',
    nit:'',
    nombreTarjeta: '',
    numeroTarjeta:'',
    cvvTarjeta:'',
    mesExpiracion: "",
    anioExpiracion: "",
  });

  useEffect(() => {//animacion carga de datos:
    if(id === null){
      setCargando(true);
      //console.log("id cargado? ID:",id);
    }
    else{
      setCargando(false);
      //console.log("id cargado? ID:",id);
    }
  }, [id]);

  useEffect(() => {  //consulta multiple de datos
    if(slug === null) return
    const obtenerDatos = async () => {
      try {
        //console.log(slug)
        const response = await fetch(`${process.env.REACT_APP_URL_BACKEND}/consulta-inicial`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ slug }) // Enviar el id en el cuerpo de la solicitud
        });
    
        const dataJ = await response.json();
        setId(dataJ.establecimiento.id_establecimiento);
        //console.log("Resultados de las consultas:", dataJ);
        //console.log("Resultado de Establecimientos:", dataJ.establecimiento);
        setEstablecimiento(dataJ.establecimiento)
        //console.log("Resultado de Horarios:", dataJ.horario);
        if(dataJ.horario !== null){
          formatearHorarios(dataJ.horario)
          //console.log("Horario no es null")
        }
        else{
          //console.log("Horario si es null")
          setHorario(null)
        }
        //console.log("Resultado de canchas Fut5:", dataJ.canchaF5);
        setCanchaF5(dataJ.canchaF5)
        //console.log("Resultado de Canchas Fut7:", dataJ.canchaF7);
        setCanchaF7(dataJ.canchaF7)
        setConsultaInicial(true)
      } catch (error) {
        console.error("Error al obtener datos:", error);
      } finally {
        setCargando(false)
      }
    };
    obtenerDatos();
  },[slug])

  useEffect(() => {  //consulta de reservas segun dia seleccionado
    if(id === null || !consultaInicial)  {
      //console.log("Consulta inicial es falsa")
      return
    }
    const fecha = formatearFecha(selectedDate)
    const obtenerDatosR = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_URL_BACKEND}/consulta-reservas`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ 
            id: id,
            fecha: fecha, 
          }) // Enviar el id y fecha en el cuerpo de la solicitud
        });
        const dataR = await response.json();
        //console.log("Resevas de la fecha elegida:", dataR);
        setReservasActivas(dataR)
      } catch (error) {
        setReservasActivas(null);
        console.error("Error al obtener datos:", error);
      }
    };  
    obtenerDatosR();
  },[id, selectedDate,contadorReservas, consultaInicial])


  const handleFieldTypeChange = (tipo) => {
    setSelectedTipoCancha(tipo)
    if(tipo === "fut5") {
      setDeposito(canchaF5[0].Deposito)
      setPrecio(canchaF5[0].Precio)
    }
    else{
      setDeposito(canchaF7[0].Deposito)
      setPrecio(canchaF7[0].Precio)
    }
  }

  const handleHoraChange = (tipo) => {
    setSelectedHora(tipo)
  }

  useEffect(() => { //Crear arreglo de fechas en las que el establecimiento esta abierto para reservar
    if(horario === null) return
    const dates = []
    
    for (let i = 0; i < 7; i++) {
      const date = new Date()
      date.setDate(date.getDate() + i) // Increment day by i
      const NombreDia = diasSemana.current[date.getDay()]
      if(horario[NombreDia][0] !== null) {
        dates.push(date)
      }
    }
    setFechasParaSeleccionar(dates)
    //console.log("fecha inicial seleccionada:")
    //console.log(dates)
    setSelectedDate(dates[0])

  },[horario])

  useEffect(() => {  // seleccionamos el boton fut5 o fut 7 para la reserva.
    if(canchaF5 || canchaF7){
      if(canchaF5.length > 0){
        setSelectedTipoCancha("fut5")
        setDeposito(canchaF5[0].Deposito)
        setPrecio(canchaF5[0].Precio)
        //console.log("cancha fut5 seleccionada")
      }
      else if(canchaF7.length > 0){
        setSelectedTipoCancha("fut7")
        setDeposito(canchaF7[0].Deposito)
        setPrecio(canchaF7[0].Precio)
        //console.log("cancha fut7 seleccionada")
      }
    }
  },[canchaF5,canchaF7])

  useEffect(() => {  //Generar arreglo de horas para seleccionar el horario de la reserva.
    if(horario === null || reservasActivas === null || Establecimiento === null) return
    const NombreDia = diasSemana.current[selectedDate.getDay()]
    if (horario[NombreDia][0]) {
      //Usar las reservas para ir quitando las horas en las que no haya ninguna cancha por asignada
      const [horaApertura, horaCierre] = horario[NombreDia];
      const resultado = [];
      let hora = parseInt(horaApertura.split(":")[0], 10); // Solo tomamos la hora
      let horaFin = parseInt(horaCierre.split(":")[0], 10);
      if(horaFin === 0){
        horaFin = 24;
      }
      const today = new Date()
      const Ftoday = formatearFecha(today)
      const FselectedDate = formatearFecha(selectedDate)
      if(Ftoday === FselectedDate){ //Si la fecha seleccionada es el dia de hoy, solo mostrar las horas posteriores a la actual
        const miHora = today.getHours();
        if(miHora === hora){
          if(today.getMinutes() > 30){
            hora = hora + 1
          }
        }
        else if(miHora > hora){
          hora = miHora + 1
          if(today.getMinutes() > 30){
            hora = hora + 1
          }
        }
      }
      const totalCanchasF5 = canchaF5.length
      const totalCanchasF7 = canchaF7.length
      let disponibleF5 = false;
      let disponibleF7 = false;
      //console.log("hay "+totalCanchasF5+" canchasF5 disponibles por hora")
      //console.log("hay "+totalCanchasF7+" canchasF7 disponibles por hora")
      const dependientesF5 = canchaF5.filter( //Obtenemos las canchasF5 que dependen de F7
        (cancha) => 
          cancha.id_canchaFut7 !== null
      )
      //console.log("el siguiente numero de canchasC5 dependen de una cancha fut7: ")
      //console.log(dependientesF5)
      const obtenerMenorCantidad = () => {
        // Crear un objeto para contar ocurrencias
        const contador = {};
    
        canchaF5.forEach((item) => {
          if (item.id_canchaFut7 === null) {
            //console.log("item id null: "+item.id_canchaFut7)
            contador[item.id_canchaFut7] = 0
          }
          else{
            contador[item.id_canchaFut7] = (contador[item.id_canchaFut7] || 0) + 1;
          }
          
        });
        // Encontrar la menor cantidad
        //console.log(contador)
        const menorCantidad = Math.min(...Object.values(contador));
        return menorCantidad;
      };
      const menorF7 = obtenerMenorCantidad();
      //console.log(`La canchaF7 de menor cantidad de canchasF5 contiene el siguiente numero de canchasF5: ${menorF7}`);

      while (hora < horaFin) {
        const horaActual = `${hora.toString().padStart(2, "0")}:00`; // Formato "HH:00"
        const horaFormato = `${hora.toString().padStart(2, "0")}:00:00` // Hora con formato de datos obtenidos en servidor
        const reservasF5Hora = reservasActivas.filter( //Obtenemos las reservas activas por cada hora
          (reserva) => 
            reserva.hora === horaFormato && reserva.tipo_cancha === 5
        )
        const reservasF5 = reservasF5Hora.length
        //console.log("reservasactivas.filter",reservasActivas);
        const reservasF7Hora = reservasActivas.filter( //Obtenemos las reservas activas por cada hora
          (reserva) => 
            reserva.hora === horaFormato && reserva.tipo_cancha === 7
        )
        const reservasF7 = reservasF7Hora.length
        
        //console.log("Las reservas en la hora "+hora+" tienen "+reservasF5+ " Reservas Activas C5")
        //console.log("Las reservas en la hora "+hora+" tienen "+reservasF7+ " Reservas Activas C7")

        const DisponiblesF5 = totalCanchasF5 - reservasF5
        const DisponiblesF7 = totalCanchasF7 - reservasF7
        //console.log("quedan disponibles el siguiente numero de reservas c5: "+DisponiblesF5)
        //console.log("quedan disponibles el siguiente numero de reservas c7: "+DisponiblesF7)
        //Calculo de disponibilidad para canchas de fut5
        if(DisponiblesF5 <= 0){
          disponibleF5 = false
          //console.log("disponiblesF5("+DisponiblesF5+") <= 0")
          //console.log("entonoces DisponibleF5 = false")
        }
        else{
          //console.log("disponiblesF5("+DisponiblesF5+") > 0")
          const resultanteF5 = DisponiblesF5 - dependientesF5.length
          //console.log("ResultantesF5: "+resultanteF5)
          if(resultanteF5 > 0){
            //console.log("resultanteF5("+resultanteF5+") > 0")
            //console.log("entonoces DisponibleF5 = true")
            disponibleF5 = true
          }
          else{
            //console.log("resultanteF5("+resultanteF5+") <= 0")
            if(DisponiblesF7 <= 0){
              //console.log("DisponiblesF7("+DisponiblesF7+") <= 0")
              //console.log("entonoces DisponibleF5 = false")
              disponibleF5 = false
            }
            else{
              //console.log("DisponiblesF7("+DisponiblesF7+") <= 0")
              //console.log("entonoces DisponibleF5 = true")
              disponibleF5 = true
            }
          }
        }
        
        //Calculo de disponibilidad para canchas de fut7
        if(totalCanchasF5 !== 0){ //si no existe cancha de F5, omitir este calculo y hacer una comparacion simple
          if(DisponiblesF7 <= 0){
            //console.log("DisponiblesF7("+DisponiblesF7+") <= 0")
            //console.log("entonoces DisponibleF7 = false")
            disponibleF7 = false
          }
          else{
            if(DisponiblesF5 >= menorF7){
              //console.log("disponiblesF5("+DisponiblesF5+") >= menorF7("+menorF7+")")
              //console.log("entonoces DisponibleF7 = true")
              disponibleF7 = true
            }
            else{
              //console.log("disponiblesF5("+DisponiblesF5+") < menorF7("+menorF7+")")
              //console.log("entonoces DisponibleF7 = false")
              disponibleF7 = false
            }
          }
        }
        else{
          if(DisponiblesF7 > 0){
            disponibleF7 = true
          }
          else{
            disponibleF7 = false
          }
        }
          
        resultado.push({ hora: horaActual, disponibleF5: disponibleF5, disponibleF7: disponibleF7 })
        //console.log("Disponibilidad de reserva en el horario actual: "+ disponibleF7)

        hora++; // Incrementa la hora
      }
      //console.log("resultado")
      //console.log(resultado)
      if(resultado.length !== 0){ //Si el resultado del arreglo creado es 0 no almacena nada porque no hay hora disponible
        setHoras(resultado); // Guarda el arreglo en el estado
        setSelectedHora(null)
        //console.log("Lista horas actuales: ")
        //console.log(resultado)
      }
      else{ // si el resultado del arreglo es 0 se reinicia el arreglo Horas y SelectedHora para no mostrar nada en pantalla
        setHoras([])
        setSelectedHora(null)
      }
    }

  },[horario,selectedDate,reservasActivas,canchaF5,canchaF7, Establecimiento])

  const formatearFecha = (NfDate) => {  //Dar formato AAAA-MM-DD a la fecha
    const anio = NfDate.getFullYear();
    const mes = String(NfDate.getMonth() + 1).padStart(2, '0');
    const dia = String(NfDate.getDate()).padStart(2, '0');
    const fecha = anio + "-" + mes + "-" + dia
    return fecha
  }

  const formatearHorarios = (NfHorario) => {
    //console.log("formateando el horario")
    const horarioTransformado = diasSemana.current.reduce((resultado,dia) => {
      const apertura = NfHorario[`${dia}Apertura`] || null; // Si no existe, asigna null
      const cierre = NfHorario[`${dia}Cierre`] || null; // Si no existe, asigna null
      resultado[dia] = [apertura, cierre];
      return resultado;
    },{})
     setHorario(horarioTransformado)
     //console.log(horarioTransformado)
  }

  useEffect (() => {
    if(captchaToken ==="" || !isFormOpen) return

  })

  useEffect(()=> {
    if(selectedHora === null){
      setFormOpen(false)
    }
  },[selectedHora])

  const openForm = () => {
    if(selectedHora === null){
      notification("Porfavor, seleccione la hora a la que desea realizar su reservación.","warning",5000);
      return
    }
    setFormOpen(true)
    setCargando(true)
    setTimeout(() => {
      setCargando(false)
    }, 500);

  }
  const closeForm = () => {
    setFormOpen(false)
    clearForm();
  }

  const clearForm = () => {
    setDatos({
    email: '',
    nombre:'',
    apellido:'',
    telefono:'',
    nit:'',
    nombreTarjeta: '',
    numeroTarjeta:'',
    cvvTarjeta:'',
    mesExpiracion: "",
    anioExpiracion: "",
  });
  setValidCard(null);

  }

  const getTipoCanchaNumero = (tipoCancha) => {
    if(tipoCancha === "fut5") return 5
    else return 7
  }

  const handleSubmit = async (e) => {
    e.preventDefault();

    const camposConError = Object.values(errors).filter((e) => e);
    if (camposConError.length > 0 || !captchaToken || !validCard) {
      notification("Por favor corrige los errores antes de enviar y verifica el captcha antes de enviar.","error",5000);
      return;
    }
    setCargaReserva(true)
    //console.log("Datos Completos sin nit:",datos);
    const DatosReserva = {
      nombre: datos.nombre,
      apellido: datos.apellido,
      telefono: datos.telefono,
      email: datos.email,
      nit: datos.nit.trim() === "" ? "CF" : datos.nit
    }
    
    try {
      const verificacion = await axios.post(`${process.env.REACT_APP_URL_BACKEND}/verificar-captcha`, {
        token: captchaToken,
      });
      if (!verificacion.data.success) {
        setCargaReserva(false);
        notification("Verificación de captcha fallida.","error",3000);
        alert()
        turnstileRef.current?.reset();
        setCaptchaToken("");
        return;
      }
      const tipo = getTipoCanchaNumero(selectedTipoCancha);
      const diaToSend = formatearFecha(selectedDate);
      const datosEstablecimiento = {
        id_establecimiento: Establecimiento.id_establecimiento,
        nombre: Establecimiento.nombre,
        telefono: Establecimiento.telefono,
        WhatsApp: Establecimiento.WhatsApp,
      }
      const dataToSend = {
        Establecimiento:datosEstablecimiento,
        tipo_cancha: tipo,
        dia: diaToSend,
        hora: selectedHora,
        cliente: DatosReserva,
        deposito: deposito,
        precio: precio,
      }
      //console.log(dataToSend)
      
        const reservaResponse = await fetch(`${process.env.REACT_APP_URL_BACKEND}/pre-crear-reserva`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(dataToSend),
        });
  
        const data = await reservaResponse.json()

        if (reservaResponse.ok && data.success) {
            
            setFormOpen(false)
            setContadorReservas(contadorReservas + 1)
            const idReserva = data.id;
            const reserva = {
              IdReserva: idReserva,
              Establecimiento:Establecimiento,
              tipo_cancha: tipo,
              fecha: diaToSend,
              hora: selectedHora,
              cliente: datos,
              deposito: deposito,
              precio: precio,
            }
            const MontoPago = deposito + 1;
            const payload = {
              method_payment: 'PAGALO',
              type_detail: 'Deposito de cancha',
              total_amount: MontoPago,
              currency: 'GTQ',
              client: {
                first_name: datos.nombre,
                last_name: datos.apellido,
                phone: datos.telefono,
                email: datos.email,
                country: 'GT',
              },
              detail: [
                {
                  uuid_product: idReserva.toString(),  //Obligatorio aunque la documentacion indique que no
                  name: `Alquiler de cancha ${selectedTipoCancha}`,
                  amount: deposito,
                  quantity: '1',
                  Subtotal: deposito, // usar S mayuscula aunque la documentacion indique minuscula
                },
                {
                  uuid_product: '1',
                  name: 'Servicio de reserva',
                  amount: 1,
                  quantity: '1',
                  Subtotal: 1,
                }
              ],
              card_payment: {
                name_card: datos.nombreTarjeta,
                expiration_month: datos.mesExpiracion,  // número, no string formData.mesExpiracion
                expiration_year: datos.anioExpiracion.slice(-2),  //formData.anioExpiracion.toString().slice(-2) número, no string - probar 4 digitos pero puede ser que haya que cambiar a 2
                number_card: datos.numeroTarjeta, //valor de prueba: 4000000000000416
                cvv_card: datos.cvvTarjeta,
                quota_active: false,
                quota: 1,
              }
            };
            
            try{
              let pagoResponse;

              if(Establecimiento.id_establecimiento === 113){
                pagoResponse = {
                  error: false,
                  message: "pago exitoso"
                }
              } else {
                pagoResponse = await axios.post(
                process.env.REACT_APP_URL_PAYMENT,
                payload,
                {
                  maxBodyLength: Infinity,
                  headers: {
                    Authorization: process.env.REACT_APP_PAYMENT_CREDENTIALS,
                    'Content-Type': 'application/json',
                  },
                }
                );
                console.log("Respuesta de pago:");
                console.log(pagoResponse);
              }
                
              if(!pagoResponse.error){

                const confirmacionResponse = await fetch(`${process.env.REACT_APP_URL_BACKEND}/confirmar-reserva`, {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json"
                  },
                  body: JSON.stringify({ id_reserva: idReserva })
                });
            
                const dataConfirmacion = await confirmacionResponse.json();

                if (confirmacionResponse.ok && dataConfirmacion.success) {
                  //console.log("Reserva confirmada");
                  setCargaReserva(false)
                  navigate("/Reserva-creada", { state: {reserva}})
                } else {
                  console.error("Error al confirmar reserva:", dataConfirmacion.message);
                  notification("No se pudo confirmar la reserva.","error",4000);
                }
              }
            }
            catch (errorPago){
              console.error("Error al procesar el pago:", errorPago);
              console.log("Respuesta de pago:");
              console.log(errorPago);
              const descripcionPago = errorPago?.response?.data?.data?.error_code[0]?.description ?? "Error desconocido";
                //console.log("Pago rechazado:", descripcionPago);
                notification("No se pudo procesar el pago: " + descripcionPago,"error",4000);
            }

        } else {
          notification(`Error al crear la reserva: ${data.message}`,"error",4000);
        }
    } catch (error) {
        console.error('Error:', error)
        notification('Error al conectar con el servidor.',"error",4000);
        setCargaReserva(false)
        setCaptchaToken("");
        turnstileRef.current?.reset();
    }
    finally{
      setCargaReserva(false);
    }
  }

  useEffect(()=> { //reiniciar la hora seleccionada cada vez que se cambia de tipo de cancha para evitar errores.
    setSelectedHora(null)
  },[selectedTipoCancha])

  //Funcion para validar datos del formulario

  useEffect(() => {
    validarFechaExpiracion(datos.mesExpiracion, datos.anioExpiracion);
  }, [datos.mesExpiracion, datos.anioExpiracion]);

  const validarCampo = (name, value) => {
    let error = "";

    switch (name) {
      case "nombre":
      case "apellido":
      case "nombreTarjeta":
        if (!/^[a-zA-ZÁÉÍÓÚÑáéíóúñ\s]*$/.test(value)) {
          error = "Solo se permiten letras";
        }
        break;
      case "telefono":
        if (!/^\d{8}$/.test(value)) {
          error = "Debe tener 8 dígitos";
        }
        break;
      case "email":
        const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,63}$/;
        const dominiosBloqueados = ['tempmail.com', 'mailinator.com', '10minutemail.com'];
        if (!emailRegex.test(value)) {
          error = "Correo no válido";
        } else {
          const dominio = value.split('@')[1];
          if (dominiosBloqueados.includes(dominio)) {
            error = "Dominio no permitido";
          }
        }
        break;
      case "nit":
        if (value === "") {
          error = ""; // limpiar error si se borra todo
        } else if (!/^\d{1,13}$/.test(value)) {
          error = "Debe contener solo números y máximo 13 dígitos";
        }
        break;
      case "numeroTarjeta":
        if (!/^\d{12,19}$/.test(value)) {
          error = "Debe tener entre 12 y 19 dígitos ";
        }
        if(value.replace(/\D/g, '').length >= 12){
          setValidCard(isValidCardNumber(value));
        }
        else{
          setValidCard(null);
        }
        break;
      case "cvv":
        if (!/^\d{3,4}$/.test(value)) {
          error = "Debe tener 3 o 4 dígitos";
        }
        break;
      default:
        break;
    }

    setErrors((prev) => ({ ...prev, [name]: error }));
  };

  const isValidCardNumber = (cardNumber) => {
    // Elimina espacios o guiones
    const sanitized = cardNumber.replace(/[\s-]/g, '');
  
    // Verifica que solo tenga dígitos
    if (!/^\d+$/.test(sanitized)) return false;
  
    let sum = 0;
    let shouldDouble = false;
  
    // Recorre desde el final
    for (let i = sanitized.length - 1; i >= 0; i--) {
      let digit = parseInt(sanitized[i], 10);
  
      if (shouldDouble) {
        digit *= 2;
        if (digit > 9) digit -= 9;
      }
  
      sum += digit;
      shouldDouble = !shouldDouble;
    }
  
    return sum % 10 === 0;
  };

  const validarFechaExpiracion = (mes, anio) => {
    let error = "";
    if (mes && anio) {
      const fechaIngresada = new Date(Number(anio), Number(mes), 0); // último día del mes
      const hoy = new Date();
      if (fechaIngresada < hoy) {
        error = "Tarjeta vencida";
      }
    }
    setErrors((prev) => ({ ...prev, fechaExpiracion: error }));
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setDatos((prev) => ({ ...prev, [name]: value }));
    if (name === "mesExpiracion" || name === "anioExpiracion") {
      validarFechaExpiracion(
        name === "mesExpiracion" ? value : datos.mesExpiracion,
        name === "anioExpiracion" ? value : datos.anioExpiracion
      );
    } else {
      validarCampo(name, value);
    }
  };

  const handleVerify = useCallback(async (token) => {
        setCaptchaToken(token);
      }, []);

  const showEfectivoMessage = () =>{
      notification("Podés pagar en efectivo.","warning",3000);
    }
    const showTarjetaMessage = () =>{
      notification("Podés pagar con tarjeta.","warning",3000);
    }
    const showTransferenciaMessage = () =>{
      notification("Podés pagar por transferencia bancaria.","warning",3000);
    }
    const showEstacionamientoMessage = () => {
      notification("Area de parqueo disponible","warning",3000);
    }

  return (
    <>
      <Helmet>
        <title>{Establecimiento?.nombre ?? "Nombre no disponible"} - Chamuscón</title>
      </Helmet>
      <div className='Contenedor-Reserva'>
        <NotificationContainer/>
        {cargando && <Loader/>}
        {Establecimiento ? (<>
          {cargaReserva && <Loader/>}
            <div className='Informacion-Establecimiento'>
              <h1>{Establecimiento.nombre}</h1>
              <div className='contenedor-iconos'>
                {Establecimiento.Efectivo === "Si" &&(
                  <div className='contenedor-icono' title='Efectivo' onClick={showEfectivoMessage}><div className='icono-Efectivo'></div></div>
                )}
                {Establecimiento.Tarjeta === "Si" &&(
                  <div className='contenedor-icono' title='Tarjeta' onClick={showTarjetaMessage}><div className='icono-Tarjeta'></div></div>
                )}
                {Establecimiento.Transferencia === "Si" &&(
                  <div className='contenedor-icono' title='Transferencia' onClick={showTransferenciaMessage}><div className='icono-Transferencia'></div></div>
                )}
                {Establecimiento.Parqueo === "Si" && (
                  <div className='icono-parqueo' title='Estacionamiento' onClick={showEstacionamientoMessage}>P</div>
                )}
                {Establecimiento.WhatsApp !== "" && (
                  <a
                    href={`https://wa.me/502${Establecimiento.WhatsApp}`}
                    target='_blank'
                    rel='noopener noreferrer'
                    className='link-whatsapp'
                    title='WhatsApp'
                  >
                    <div className='contenedor-icono-Whatsapp'><div className='icono-whatsapp'></div></div>
                  </a>
                )}
              </div>
              <div className='Caja-Detalles'>
                <h3>{Establecimiento.direccion}</h3>
                <h3><a href={`tel:+502${Establecimiento.telefono}`}>+502 {Establecimiento.telefono}</a></h3>
              </div>
              <div className='Contenido-Establecimiento'>
                <p className='Descripcion-Establecimiento' style={{ whiteSpace: 'pre-line' }}>{Establecimiento.Descripcion}</p>{/*Cambiar por informacion obtenida de la base de datos*/}
              </div>
              <div className='Contenedor-Horario'>
                {(Establecimiento.Estado === "Afiliado") &&
                <>
                <p className='nota-cancha'>Para reservar una cancha deberás hacer el pago del depósito.</p>
                {canchaF5.length > 0 &&
                  <>
                    <table className='table-precios'>
                      <thead>
                        <tr>
                          <th style={{minWidth: '50px'}}>
                            <p>Fut 5:</p>
                          </th>
                          <th><p>&nbsp;Precio: Q.{canchaF5[0].Precio}.00&nbsp;</p></th>
                          <th><p>&nbsp;Depósito: Q.{canchaF5[0].Deposito}.00&nbsp;</p></th>
                        </tr>
                      </thead>
                    </table>
                  </>
                }
                {canchaF7.length > 0 &&
                <>
                  <table className='table-precios'>
                    <thead>
                      <tr>
                        <th style={{minWidth: '50px'}}>
                          <p>Fut 7:</p>
                        </th>
                        <th><p>&nbsp;Precio: Q.{canchaF7[0].Precio}.00&nbsp;</p></th>
                        <th><p>&nbsp;Depósito: Q.{canchaF7[0].Deposito}.00&nbsp;</p></th>
                      </tr>
                    </thead>
                  </table>
                </>
                }
                <p className='nota-cancha'>Elige el tipo de cancha y la hora para hacer tu reserva.</p>
                  <div className='Selector-cancha'>
                    {canchaF5.length > 0 && 
                      <div onClick={() => handleFieldTypeChange("fut5")} className={`cancha-opcion ${selectedTipoCancha === "fut5" ? "selected" : ""}`}>
                        Fut 5
                      </div>
                    }
                    {canchaF7.length > 0 && 
                      <div onClick={() => handleFieldTypeChange("fut7")} className={`cancha-opcion ${selectedTipoCancha === "fut7" ? "selected" : ""}`}>
                        Fut 7
                      </div>
                    }
                  </div>
                  {(canchaF5.length > 0 || canchaF7.length > 0) ? (
                    <>
                      <div className="selector-dias">
                        <select
                          value={selectedDate.toDateString()}
                          onChange={(e) => {
                            const selected = fechasParaSeleccionar.find(date => date.toDateString() === e.target.value);
                            setSelectedDate(selected);
                          }}
                        >
                          {fechasParaSeleccionar.map((date, index) => (
                            <option key={index} value={date.toDateString()}>
                              {date.toLocaleDateString('es-ES', { weekday: 'long', day: 'numeric', month: 'long' })}
                            </option>
                          ))}
                        </select>
                      </div>
                      <div className='Horario'>
                        {(horas.length === 0) ? (
                          <p>No hay horarios disponibles</p>
                        ):(
                          <>{(selectedTipoCancha === "fut5") ? (<>
                            {horas.map((item, index) => item.disponibleF5 ? (
                                <div key={index} onClick={() => handleHoraChange(item.hora)} className={`hora ${selectedHora === item.hora ? "seleccionada" : ""}`}>
                                  {item.hora}
                                </div>
                              ): null
                            )}
                          </>):(<>
                            {horas.map((item, index) => item.disponibleF7 ? (
                                <div key={index} onClick={() => handleHoraChange(item.hora)} className={`hora ${selectedHora === item.hora ? "seleccionada" : ""}`}>
                                  {item.hora}
                                </div>
                              ): null
                            )}
                          </>)}
                        </>)}
                      </div>
                    </>
                  ):(<></>)}
                </>}
                
              </div>
            </div>
            {Establecimiento.Estado === "Afiliado" && (
              <button className='Boton-Reserva-Contenido' onClick={openForm} disabled={isFormOpen} type='button'>Pagar</button>
            )}
            {isFormOpen && (
              <div className={`form-container ${isFormOpen ? "open" : ""}`}>
                <form className='form' onSubmit={handleSubmit}>
                  <div className='caja-cliente'>
                    <h3>Formulario de reserva</h3>
                    <label>
                      Nombre:
                      <input
                        type="text"
                        id="nombre"
                        name="nombre"
                        value={datos.nombre}
                        onChange={handleChange}
                        placeholder="Ejemplo: Juan"
                        required
                      />
                      {errors.nombre && <p style={{ color: '#D90429' }}>{errors.nombre}</p>}
                    </label>
                    <label>
                      Apellido:
                      <input
                        type="text"
                        id="apellido"
                        name="apellido"
                        value={datos.apellido}
                        onChange={handleChange}
                        placeholder="Ejemplo: Pérez"
                        required
                      />
                      {errors.apellido && <p style={{ color: '#D90429' }}>{errors.apellido}</p>}
                    </label>
                    <label>
                      Correo Electrónico:
                      <input
                        type="email"
                        id="email"
                        name="email"
                        value={datos.email}
                        onChange={handleChange}
                        placeholder="ejemplo@correo.com"
                      />
                      {errors.email && <p style={{ color: '#D90429' }}>{errors.email}</p>}
                    </label>
                    <label>
                    Número de Teléfono:
                      <input
                        type="tel"
                        id="telefono"
                        name="telefono"
                        value={datos.telefono}
                        onChange={handleChange}
                        placeholder="12345678"
                        required
                      />
                      {errors.telefono && <p style={{ color: '#D90429' }}>{errors.telefono}</p>}
                    </label>
                    <label>
                      NIT:
                      <input
                        type="text"
                        id="nit"
                        name="nit"
                        value={datos.nit}
                        onChange={handleChange}
                        placeholder="Si se deja vacío se usará Consumidor Final"
                      />
                      {errors.nit && <p style={{ color: '#D90429' }}>{errors.nit}</p>}
                    </label>
                  </div>
                  {/* Informacion de pago y reserva */}
                  <div className="selected-date-time">
                  <p className="warning-text">
                      Porfavor, verifique que la información de la reserva sea correcta.
                    </p>
                    <p><strong>Tipo de cancha: </strong> {selectedTipoCancha === "fut5" ? "Fut 5" : "Fut 7"}</p>
                    <p><strong>Fecha:</strong> {selectedDate.toLocaleDateString('es-ES', { weekday: 'long', day: 'numeric', month: 'long' })}</p>
                    <p><strong>Hora:</strong> {selectedHora}</p>
                    <p><strong>Depósito:</strong> Q.{deposito}.00</p> {/* Cambiar el texto por una variable */}
                    <p><strong>Costo de la cancha:</strong> Q.{precio}.00</p> {/* Cambiar el texto por una variable */}
                    <p><strong>Costo de servicio:</strong> Q.1.00</p>
                    <p className='formulario-total'>Total a pagar: Q.{deposito + 1}.00</p>
                    <p><strong>Restante a pagar en el establecimiento:</strong> Q.{precio - deposito}.00</p>
                  </div>
                  {/* Continuacion del formulario con datos para el pago */}
                  <div className='caja-pago'>
                    <h3>Datos de la tarjeta</h3>
                    <label>
                      Nombre:
                      <input
                        type="text"
                        id="nombreTarjeta"
                        name="nombreTarjeta"
                        value={datos.nombreTarjeta}
                        onChange={handleChange}
                        placeholder="Ingrese el nombre como aparece en la tarjeta"
                        required
                      />
                      {errors.nombreTarjeta && <p style={{ color: '#D90429' }}>{errors.nombreTarjeta}</p>}
                    </label>
                    <label>
                      Numero de Tarjeta:
                      <input
                        type="text"
                        id="numeroTarjeta"
                        minLength="12"
                        maxLength="19"
                        name="numeroTarjeta"
                        value={datos.numeroTarjeta}
                        onChange={handleChange}
                        placeholder="Ingrese el número sin espacios"
                        required
                      />
                      {validCard === true && <p style={{ color: '#26A96C' }}>Tarjeta válida</p>}
                      {validCard === false && <p style={{ color: '#D90429' }}>Tarjeta inválida</p>}
                      {errors.numeroTarjeta && <p style={{ color: '#D90429' }}>{errors.numeroTarjeta}</p>}
                    </label>
                    <label>
                      CVV:
                      <input
                        type="text"
                        id="cvvTarjeta"
                        name="cvvTarjeta"
                        maxLength="4"
                        value={datos.cvv}
                        onChange={handleChange}
                        placeholder="Ingrese el código de 3 o 4 digitos de su tarjeta"
                        required
                      />
                      {errors.cvv && <p style={{ color: '#D90429' }}>{errors.cvv}</p>}
                    </label>
                    <label>
                      Fecha de vencimiento:
                      <div style={{ display: 'flex', gap: '10px' }}>
                        <select
                          className='date-select'
                          name="mesExpiracion"
                          value={datos.mesExpiracion}
                          onChange={handleChange}
                          required
                        >
                          <option value="">Mes</option>
                          {[...Array(12)].map((_, i) => (
                            <option key={i + 1} value={String(i + 1).padStart(2, '0')}>
                              {String(i + 1).padStart(2, '0')}
                            </option>
                          ))}
                        </select>
                        <select
                          className='date-select'
                          name="anioExpiracion"
                          value={datos.anioExpiracion}
                          onChange={handleChange}
                          required
                        >
                          <option value="">Año</option>
                          {[...Array(15)].map((_, i) => {
                            const year = new Date().getFullYear() + i;
                            return (
                              <option key={year} value={year}>{year}</option>
                            );
                          })}
                        </select>
                      </div>
                      {errors.fechaExpiracion && <p style={{ color: '#D90429' }}>{errors.fechaExpiracion}</p>}
                    </label>
                    <p className="tarjetas-aceptadas">Aceptamos: <strong>Visa</strong> y <strong>Mastercard</strong>.</p>
                    <p className="tarjetas-aceptadas">Pago procesado por <strong>Pagalo</strong>.</p>
                  <Turnstile
                    ref={turnstileRef}
                    sitekey={process.env.REACT_APP_SITE_KEY}
                    onVerify={handleVerify}
                  />
                  </div>
                    <div className="form-buttons">
                <button type="submit" className="submit-button" > {/*disabled={errorEmail !== '' || !isFormComplete}Quitar el disabled y manejar desde el submit*/}
                  Pagar {`(Q.${deposito + 1}.00)`}
                </button>
                <button type="button" onClick={closeForm} className="cancel-button">
                  Cancelar
                </button>
              </div>
                </form>
              </div>
            )}
          </>):(<>No hay información para mostrar</>)}
        </div>
    </>
  )
}